// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1hqRW","title":"ClientInsurance_title__22Qeb","itemText":"ClientInsurance_itemText__blvDy"};